import { render, staticRenderFns } from "./CompanyManage.vue?vue&type=template&id=cb2ab24a&scoped=true"
import script from "./CompanyManage.vue?vue&type=script&lang=js"
export * from "./CompanyManage.vue?vue&type=script&lang=js"
import style0 from "./CompanyManage.vue?vue&type=style&index=0&id=cb2ab24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2ab24a",
  null
  
)

export default component.exports